import { Injectable } from '@angular/core';

import { HttpService } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class YarnProperty1ReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('YarnProperty1Reference', httpService);
  }
}
